'use client';

import { c as _c } from "react/compiler-runtime";
import { type PostFactiii } from '@shared/all/domains/factiiis';
import { useUserIdentity } from '@shared/utils/context/UserContext';
import usePostsShared from '@shared/utils/hooks/usePosts';
import { useState } from 'react';
import eventEmitter from '../../helpers/eventEmitter';
import { client } from '../../utils/trpc';
import { useAuthModals } from '../../widgets/WidgetsContext';
import Button from '../common/Button';
import Input from '../UI/Input';
type Props = {
  postId: string;
  factiii: PostFactiii;
};
const DisappearingData = props => {
  const $ = _c(19);
  const {
    openAuthContinueModal
  } = useAuthModals();
  const currentUser = useUserIdentity();
  const {
    postDataFactiii
  } = usePostsShared(client);
  const [data, setData] = useState("");
  let t0;
  if ($[0] !== props.factiii.name) {
    t0 = <p className="text-textSecondary">{props.factiii.name}</p>;
    $[0] = props.factiii.name;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-textSecondary/70">This post will disappear once you enter data</p>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => setData(e);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data) {
    t3 = <Input value={data} onChange={t2} label="Enter Data" />;
    $[4] = data;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currentUser.isAuthenticated || $[7] !== data || $[8] !== openAuthContinueModal || $[9] !== postDataFactiii || $[10] !== props.factiii.factiiiId || $[11] !== props.postId) {
    t4 = <Button text="Submit" type="button" classNames="w-28" onClick={e_0 => {
      e_0.preventDefault();
      if (!currentUser.isAuthenticated) {
        return openAuthContinueModal();
      }
      eventEmitter.emit("refetch");
      postDataFactiii(props.postId, props.factiii.factiiiId, data);
    }} />;
    $[6] = currentUser.isAuthenticated;
    $[7] = data;
    $[8] = openAuthContinueModal;
    $[9] = postDataFactiii;
    $[10] = props.factiii.factiiiId;
    $[11] = props.postId;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div className="flex gap-x-2">{t3}{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t0 || $[17] !== t5) {
    t6 = <div className="mt-2 space-y-2 rounded-md border border-ds-border-standard p-4">{t0}{t1}{t5}</div>;
    $[16] = t0;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default DisappearingData;